import { cn, FormatUtils } from '@shared/utils';
import type { UserWithPaymentInfo } from '@shared/api';
import { Icon } from '@shared/widgets';
import ReportIcon from '@assets/icons/report.svg';
import MailIcon from '@assets/icons/mail.svg';
import PhoneIcon from '@assets/icons/phone.svg';

interface UserContactsProps {
  user: UserWithPaymentInfo;
}

export const UserContacts = (props: UserContactsProps) => {
  return (
    <ul className={cn('flex flex-col gap-4 bg-white px-6 pb-8 text-sm font-medium dark:bg-soft-black', props.user.locked && 'opacity-50')}>
      {props.user.position && (
        <li className='flex items-center gap-2'>
          <Icon icon={<ReportIcon width='18' height='18' />} color='primary' />
          {props.user.position}
        </li>
      )}
      {props.user.emailAddress && (
        <li className='flex items-center gap-2'>
          <Icon icon={<MailIcon />} color='primary' />
          {props.user.emailAddress}
        </li>
      )}
      {props.user.phoneAreaCode && props.user.phoneNumber && (
        <li className='flex items-center gap-2'>
          <Icon icon={<PhoneIcon />} color='primary' />
          {FormatUtils.toPhoneFormat(props.user.phoneAreaCode, props.user.phoneNumber)}
        </li>
      )}
    </ul>
  );
};
